import { Text } from "@aurem/ui";
import { ReactNode } from "react";

type Props = {
  title: ReactNode;
  accessory?: ReactNode;
};

export const SectionHeader = ({ title, accessory }: Props) => {
  return (
    <header className="flex justify-between items-center shrink-0 h-10 px-2.5">
      <Text size="sm" className="text-neutral-500/50">
        {title}
      </Text>
      {accessory}
    </header>
  );
};
